import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
    ProductsResponseDto,
    SavingsInsightsOrderBy,
} from '../types/ReportSavingsSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSavingsProductsParams {
    dateFrom: string;
    dateTo: string;
    propertyIds?: string[];
    categoryIds?: string[];
    orderBy?: SavingsInsightsOrderBy;
    page?: number;
}

export const fetchSavingsProducts = createAsyncThunk<
    ProductsResponseDto,
    FetchSavingsProductsParams,
    ThunkConfig<string>
>(
    'reportSavingsSummary/fetchSavingsProducts',
    async (
        {
            dateFrom,
            dateTo,
            propertyIds,
            categoryIds,
            orderBy = '-total_saved',
            page = 1,
        },
        thunkApi,
    ) => {
        const { extra, rejectWithValue } = thunkApi;
        try {
            const params: Record<string, string | number> = {
                date_from: dateFrom,
                date_to: dateTo,
                order_by: orderBy,
                page,
            };
            if (propertyIds?.length) {
                params.property_ids = propertyIds.join(',');
            }
            if (categoryIds?.length) {
                params.category_ids = categoryIds.join(',');
            }
            const response = await extra.api.get<ProductsResponseDto>(
                '/v1/reports/savings-insights/products',
                { params },
            );
            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
